import React from "react";
import { Nav, NavItem, Button } from "reactstrap";
import ToolbarWrapper from "../../../system/containers/Table/components/Toolbar";
import { checkPermissions } from "../../../system/utils/UserPermissions";

const Toolbar = props => {
  return (
    <ToolbarWrapper>
      <Nav>
        {checkPermissions(props.permissions, ["ALL", "ADD_HOTELS"]) && (
          <NavItem>
            <a href={props.createLink}>
              <Button size="sm" color="success">
                Add New
              </Button>
            </a>
          </NavItem>
        )}
        {checkPermissions(props.permissions, ["ALL", "DELETE_HOTELS"]) && (
          <NavItem>
            <Button size="sm" onClick={() => props.handleDelete()}>
              <i className="far fa-trash-alt" /> Delete Selected
            </Button>
          </NavItem>
        )}
        <NavItem className="ml-auto">{props.total} Hotels</NavItem>
      </Nav>
    </ToolbarWrapper>
  );
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/containers/Hotels/components/Toolbar.jsx